// Reads the single threshold definition — styles/global/_phone-layout.scss — off the DOM.
// No breakpoint number lives here; JS never re-derives it.
export const isPhoneLayoutFromCSS = (): boolean => {
  const appContainer = document.querySelector(".appContainer");
  if (!appContainer) return false;

  const value = getComputedStyle(appContainer)?.getPropertyValue?.("--oc-phone-layout");
  return value?.trim() === "1";
};
